import React from "react";

class MapErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.warn("Map error caught:", error.message);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.vehicleId !== this.props.vehicleId) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            height: "500px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "1px solid #ddd",
            borderRadius: "8px",
          }}
        >
          Loading map...
        </div>
      );
    }

    return this.props.children;
  }
}

export default MapErrorBoundary;
